export const DEFAULT_QUESTIONS = [
  {
    id: "email",
    questionType: "Personal Data",
    minNAnswers: 1,
  },
  {
    id: "email_validation",
    questionType: "Personal Data",
    minNAnswers: 1,
  },
];

export const QUESTIONS = [
  {
    id: "guest_name",
    questionType: "Short answer",
    minNAnswers: 0,
  },

  {
    id: "transfer",
    questionType: "Checkboxes",
    answers: [
      {
        id: "transfer_text",
      },
    ],
    minNAnswers: 0,
  },
];

export const getQuestionLabel = (questionId, labels) => {
  return labels?.[`EVENT_SURVEY_${questionId.toUpperCase()}`] || questionId;
};

export const isStageAvailable = (stage) => {
  return typeof stage?.availableSeats === "number" ? stage?.availableSeats > 0 : true;
};
